import { EXTENSION_FRAME_ID } from '../constants';

function getIFrameElement(): HTMLIFrameElement | null {
  return document.getElementById(EXTENSION_FRAME_ID) as HTMLIFrameElement;
}

export function getIFrameDocument(): Document | undefined {
  const iframe = getIFrameElement();
  return iframe?.contentDocument || iframe?.contentWindow?.document;
}

export function getIFrameWindow(): Window | null {
  const iframe = getIFrameElement();
  return iframe?.contentWindow;
}
